import { render, staticRenderFns } from "./PixQrCode.vue?vue&type=template&id=32f00c91&scoped=true"
import script from "./PixQrCode.vue?vue&type=script&lang=js"
export * from "./PixQrCode.vue?vue&type=script&lang=js"
import style0 from "./PixQrCode.vue?vue&type=style&index=0&id=32f00c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f00c91",
  null
  
)

export default component.exports